import ApiService from "../../ApiService";

const CrawlService = {
    crawlWord: (vo, successCallback, failureCallback) => {
        ApiService.post("/web/admin/dictionary/word/edit/save", vo, successCallback, failureCallback);
    },
    getWordDetails: (vo, successCallback, failureCallback)=> {
        ApiService.post("/common/dictionary/word", {...vo}, successCallback, failureCallback);
    },
    getLetterDetails: (vo, successCallback, failureCallback)=> {
        ApiService.post("/common/dictionary/letter", {...vo}, successCallback, failureCallback);
    }
};

export default CrawlService;
